import { EntityState } from '@ngrx/entity';
import { usersAdapter } from './users-adapters';
import { UserRole } from '../enums/user-role-enum';
import { UserStatus } from '../enums/user-status-enum';
import { blsUser } from '../../../models/users-models/blsUser';

export interface BlsUsersState extends EntityState<blsUser> {
}

export interface UsersFeatureState {
  blsUsers: BlsUsersState;
  blsUsersLoading: boolean;
  availableUserRoles: UserRole[],
  availableUserStatuses: UserStatus[],
  filterModel: { [key: string]: any },
}

export const InitialState: UsersFeatureState = {
  blsUsers: usersAdapter.getInitialState(),
  blsUsersLoading: false,
  availableUserRoles: [],
  availableUserStatuses: [],
  filterModel: {},
};
